let setSessionExpiredGlobal = null;

export const authStore = {
  setSetter: (setter) => {
    setSessionExpiredGlobal = setter;
  },
  triggerSessionExpired: () => {
    if (setSessionExpiredGlobal) {
      setSessionExpiredGlobal(true);
    }
  },
};
